import { useCallback } from "react"
import { batch, useSignal } from "@preact/signals-react"
import { dsRepricingDrawerData } from "Pages/DsRepricing/Page/@signals"

export default function useDsRepricingDataInfo(value) {
	const dataInfo = useSignal(value)

	const setDataInfo = useCallback((value, key) => batch(() => {
		dataInfo.value = value
		dsRepricingDrawerData.value = { ...dsRepricingDrawerData.value, [key]: value }
	}), [])

	return { dataInfo, setDataInfo }
}
